import styled from 'styled-components';

export const OverviewMetricValue = styled.div`
    font-size: 1.5rem;
    font-weight: ${({ theme }) => theme.fontExtrabold};
    height: 2rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-transform: uppercase;
`;

export const OverviewMetricLabel = styled.div`
    font-size: 0.75rem;
    font-weight: ${({ theme }) => theme.fontBold};
    text-transform: capitalize;
`;
